export const paginationMixin = function(resourceObject) {
  return {
    computed: {
      paginationPageSize() {
        if (this.gridApi) return this.gridApi.paginationGetPageSize();
        else return 15;
      },
      totalPages() {
        return this[resourceObject]
          ? Math.ceil(this[resourceObject].total / this.paginationPageSize)
          : null;
      }
    }
  };
};
